import { useState, ReactNode } from 'react';
import { AiAssistantContext } from './AiAssistantContext';

export function AiAssistantProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [onTemplateCreated, setOnTemplateCreated] = useState<((template: unknown) => void) | null>(null);

    const openAssistant = () => {
        setIsOpen(true);
        setIsMinimized(false);
    };
    const closeAssistant = () => setIsOpen(false);

    return (
        <AiAssistantContext.Provider value={{ 
            isOpen, 
            isMinimized,
            openAssistant, 
            closeAssistant, 
            setIsMinimized,
            onTemplateCreated,
            setTemplateCreatedCallback: setOnTemplateCreated 
        }}>
            {children}
        </AiAssistantContext.Provider>
    );
}
